/** ***
------------------------------------------------------------------------
CONTAINER LIST PAGE
------------------------------------------------------------------------
 {
        "containerId": "b1d761bc490c5a3dc9918f36cc5993d1fbd97dd95aac5ea5702635362733db18",
        "containerImageId": "sha256:771f96b0b1bb7ee0701d8c234dae27d1ba13b9afdca8aa85aebe520ae691c9fc",
        "containerMetadata": {
            "containerConfig": {
                "configArgs": [],
                "configEnv": [
                    "PATH=/usr/lib/postgresql/9.6/bin:/usr/local/tomcat/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin",
                    "LANG=C.UTF-8",
                    "JAVA_HOME=/docker-java-home",
                    "JAVA_VERSION=11.0.3",
                    "JAVA_DEBIAN_VERSION=11.0.3+1-1~bpo9+1",
                    "CATALINA_HOME=/usr/local/tomcat",
                    "TOMCAT_NATIVE_LIBDIR=/usr/local/tomcat/native-jni-lib",
                    "LD_LIBRARY_PATH=/usr/local/tomcat/native-jni-lib",
                    "OPENSSL_VERSION=1.1.0j-1~deb9u1",
                    "GPG_KEYS=05AB33110949707C93A279E3D3EFE6B686867BA6 07E48665A34DCAFAE522E5E6266191C37C037D42 47309207D818FFD8DCD3F83F1931D684307A10A5 541FBE7D8F78B25E055DDEE13C370389288584E7 61B832AC2F1C5A90F0F9B00A1C506407564C17A3 79F7026C690BAA50B92CD8B66A3AD3F4F22C4FED 9BA44C2621385CB966EBA586F72C284D731FABEE A27677289986DB50844682F8ACB77FC2E86E29AC A9C5DF4D22E99998D9875A5110C01C5A2F6059E7 DCFD35E0BF8CA7344752DE8B6FB21E8933C60243 F3A04C595DB5B6A5F1ECA43E3B7BBB100D811BBE F7DA48BB64BCB84ECBA7EE6935CD23C10D498E23",
                    "TOMCAT_MAJOR=9",
                    "TOMCAT_VERSION=9.0.20",
                    "TOMCAT_SHA512=6d2df51f0bfc6a90cfca61c86473b8843da4162c430ab06b8f66f364931f3d8a3ad399703acdd600ff4f633d7d6725edf05d5d5d19534716a2f3f9f5238a32a0",
                    "TOMCAT_TGZ_URLS=https://www.apache.org/dyn/closer.cgi?action=download&filename=tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz \thttps://www-us.apache.org/dist/tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz \thttps://www.apache.org/dist/tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz \thttps://archive.apache.org/dist/tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz",
                    "TOMCAT_ASC_URLS=https://www.apache.org/dyn/closer.cgi?action=download&filename=tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz.asc \thttps://www-us.apache.org/dist/tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz.asc \thttps://www.apache.org/dist/tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz.asc \thttps://archive.apache.org/dist/tomcat/tomcat-9/v9.0.20/bin/apache-tomcat-9.0.20.tar.gz.asc",
                    "ARCH=amd64",
                    "GUAC_VER=1.1.0",
                    "GUACAMOLE_HOME=/config/guacamole",
                    "PG_MAJOR=9.6",
                    "PGDATA=/config/postgres",
                    "POSTGRES_USER=guacamole",
                    "POSTGRES_DB=guacamole_db"
                ],
                "configIpAddress": "172.17.0.2",
                "configMounts": [
                    {
                        "mountDestinationPath": "/config",
                        "mountRW": true,
                        "mountSourcePath": "/opt/guacamole/config",
                        "mountType": "bind"
                    },
                    {
                        "mountDestinationPath": "/filetransfer",
                        "mountRW": true,
                        "mountSourcePath": "/opt/guacamole/filetransfer",
                        "mountType": "bind"
                    }
                ],
                "configNetworkMode": "default",
                "configPath": "/init",
                "configPrivileged": false
            },
            "containerId": "b1d761bc490c5a3dc9918f36cc5993d1fbd97dd95aac5ea5702635362733db18",
            "containerImageId": "sha256:771f96b0b1bb7ee0701d8c234dae27d1ba13b9afdca8aa85aebe520ae691c9fc",
            "containerNames": [
                "/guacamole"
            ],
            "containerStartTime": 1618361149665135773,
            "containerType": "DOCKER"
        },
        "containerNames": [
            "/guacamole"
        ],
        "managed": true,
        "numDetections": 0,
        "numProgressions": 0,
        "snykPresence": false
    },

** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const containerDetailMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'expand',
        description: 'More Details',
        label: 'More Details',
        sortable: false,
        'min-width': 150,
        name: 'expand',
        component: 'ExpandContainerDetails'
      },
      // {
      //   datatype: 'selection',
      //   description: 'Select',
      //   label: 'Select',
      //   sortable: false,
      //   'min-width': 55,
      //   name: 'selection'
      // },
      {
        datatype: 'array',
        description: 'Container',
        label: 'Container',
        sortable: true,
        'min-width': 150,
        name: 'containerNames'
      },
      {
        datatype: 'string',
        description: 'Source',
        label: 'Source',
        sortable: true,
        'min-width': 120,
        name: 'source',
        display: 'component',
        displayKey: [
          { key: 'AWS', icon: 'table-logos-icon logo-aws-color' },
          { key: 'AZURE', icon: 'table-logos-icon logo-only-azure-color' },
          { key: 'GCP', icon: 'table-logos-icon logo-only-gcp-color' },
          { key: 'EKS', icon: 'table-logos-icon logo-aws-eks' },
          { key: 'AKS', icon: 'table-logos-icon logo-azure-aks' },
          { key: 'GKE', icon: 'table-logos-icon logo-gcp-gke' },
          { key: 'CONFLUERA', icon: 'table-logos-icon logo-confluera-color' }
        ],
        component: 'DiscoverySourceTableCell',
        componentFields: {
          discoveryKey: 'discoveryAccountNickname'
        }
      },
      {
        datatype: 'string',
        description: 'Protected',
        label: 'Protected',
        sortable: true,
        'min-width': 100,
        name: 'managed',
        display: 'colorTag',
        displayKey: [
          {
            key: true,
            display: 'Yes',
            color: '#E8ECF4',
            textColor: '#4B4E54',
            icon: 'far fa-check',
            iconDirection: 'right'
          },
          {
            key: false,
            display: 'No Agent',
            color: '#FEE5EA',
            textColor: '#EE3354',
            icon: 'fal fa-exclamation-triangle',
            iconDirection: 'right'
          },
          {
            key: 'Offline',
            display: 'Offline',
            // color: '#77dab4',
            // textColor: '#008044',
            icon: 'far fa-check',
            iconDirection: 'right'
          },
          {
            key: 'Upgrade',
            display: 'Upgrade',
            color: '#DFF6ED',
            textColor: '#00A45F',
            icon: 'fal fa-exclamation-triangle',
            iconDirection: 'right'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Needs Attention',
        label: 'Needs Attention',
        name: 'needsAttention',
        sortable: true,
        'min-width': 150,
        display: 'component',
        component: 'NeedsAttentionTableCell',
        componentFields: {
          needsAttention: 'needsAttention',
          managed: 'managed',
          upgradeable: 'upgradeable',
          numProgressions: 'numProgressions',
          accountKey: 'containerId'
        }
      },
      {
        datatype: 'number',
        description: 'Progressions',
        label: 'Progressions',
        sortable: true,
        'min-width': 125,
        name: 'numProgressions',
        display: 'link',
        pathTo: 'account-progressions',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'containerId'
          },
          {
            name: 'nickName',
            keyLookup: 'containerNames[0]'
          }
        ]
      },
      {
        datatype: 'number',
        description: 'Detections',
        label: 'Detections',
        sortable: true,
        name: 'numDetections',
        'min-width': 125,
        display: 'link',
        pathTo: 'account-iocs',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'containerId'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Vulnerable',
        label: 'Vulnerable',
        sortable: true,
        name: 'vulnerable',
        'min-width': 125
      },
      {
        datatype: 'objectpath',
        description: 'Exposed',
        label: 'Exposed',
        sortable: true,
        'min-width': 100,
        name: 'openToPublicInternet',
        display: 'colorTag',
        displayKey: [
          {
            key: true,
            display: 'Yes',
            color: '#FEE5EA',
            textColor: '#EE3354'
          },
          {
            key: false,
            display: 'No',
            color: '#E8ECF4',
            textColor: '#4B4E54'
          },
          {
            key: 'n/a',
            display: 'N/A',
            color: '#E8ECF4',
            textColor: '#4B4E54'
          }
        ]
      },
      {
        datatype: 'array',
        description: 'Business Tags',
        label: 'Business Tags',
        visible: false,
        sortable: true,
        name: 'tags',
        'min-width': 150
      },
      {
        datatype: 'runtime_string',
        format: DATETIME_FORMAT,
        description: 'Running Time',
        label: 'Running',
        name: 'upTime',
        'min-width': 150,
        sortable: true
      },
      {
        datatype: 'string',
        description: 'Agent Version',
        label: 'Agent Version',
        sortable: true,
        name: 'agentVersion',
        'min-width': 150
      },
      {
        datatype: 'string',
        description: 'Container Image Id',
        label: 'Container Image Id',
        visible: false,
        name: 'containerImageId'
      },
      {
        datatype: 'string',
        visible: false,
        description: 'Nickname',
        label: 'Nickname',
        name: 'discoveryAccountNickname',
        'min-width': 150,
        sortable: true
      }
    ]
  }
}

export { containerDetailMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/hosts/containers-meta.js